import { observer } from 'mobx-react';
import { Maybe } from 'maybeasy';
import { whenZero } from '@execonline-inc/numbers';
import { Typography, emptyFragment } from '@execonline-inc/execonline-ui';
import { T } from '../../../../../../../../Translations';

interface Props {
  remainingSeats: Maybe<number>;
}

function GroupCoachingNoAvailability({ remainingSeats }: Props) {
  return remainingSeats
    .andThen(whenZero)
    .map(() => (
      <Typography className="text-[#6A6A6A]" fontWeight="medium" variant="bodySmall">
        <T kind="No availability" />
      </Typography>
    ))
    .getOrElse(emptyFragment);
}

export default observer(GroupCoachingNoAvailability);
